import { Icon as _Icon } from 'tdesign-icons-vue';
import withInstall from '../utils/withInstall';

export const Icon = withInstall(_Icon);
export default Icon;
